import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {alabaster, black, silverChalice, white} from '/theme/color/on.color';
import {alto} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  container: {
    backgroundColor: alabaster,
    paddingHorizontal: indent * 0.85,
    paddingVertical: indent * 0.4,
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    marginTop: indent * 0.6,
  },
  icon: {
    width: 16,
    height: 16,
    fontSize: 16,
    color: silverChalice,
    marginRight: indent * 0.4,
  },
  filterContainer: {
    backgroundColor: white,
    alignItems: 'center',
    flexDirection: 'row',
    borderColor: alto,
    borderWidth: 1,
    borderRadius: 8,
    paddingVertical: indent * 0.4,
    paddingHorizontal: indent * 0.8,
  },
  result: {
    color: black,
    fontWeight: '600',
  },
});
